<template>
  <div class="text-box">
    <v-text-box logo>
      <template #box-title>{{ $t('pageHome.welcome.title') }}</template>
      <template #box-text>{{ $t('pageHome.welcome.text') }}</template>
    </v-text-box>
  </div>
</template>

<script>
import VTextBox from '@/components/modules/VTextBox.vue';

export default {
  name: 'HomeTextBox',
  components: {
    VTextBox,
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
.text-box {
  width: 650px;
}
</style>
